import { render, staticRenderFns } from "./LayoutContentMenu.vue?vue&type=template&id=2a38717c&scoped=true"
import script from "./LayoutContentMenu.vue?vue&type=script&lang=ts"
export * from "./LayoutContentMenu.vue?vue&type=script&lang=ts"
import style0 from "./LayoutContentMenu.vue?vue&type=style&index=0&id=2a38717c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38717c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTab,VTabs,VTooltip})
